import { render, staticRenderFns } from "./queryOrderDetailList.vue?vue&type=template&id=2da28c2a"
import script from "./queryOrderDetailList.vue?vue&type=script&lang=js"
export * from "./queryOrderDetailList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports